import React, { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import { Button, Select, Pagination, Spin } from 'antd';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import * as XLSX from 'xlsx';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { fetchRawProjectSummeryList } from '../../../redux/projectMargin/action';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
//ag grid enterprise
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { StatusBarModule } from "@ag-grid-enterprise/status-bar";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
// import axiosConfig from './axiosConfig';
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    MenuModule,
    SetFilterModule,
    StatusBarModule,
    RowGroupingModule
]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE)

const { Option } = Select;

const Cji3C406 = (props) => {
    const { onFetchRawProjectSummeryList, rawProjectSummeryList, isRawProjectSummeryListLoading, selectedYear, setSelectedYear, year, setYear, } = props;

    const [theme, setTheme] = useState('ag-theme-material-dark'); // Default theme
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [pageSize, setPageSize] = useState(60000);
    const [pageNumber, setPageNumber] = useState(1);
    const [selectModel, setSelectModel] = useState([]);
    const [loadingRows, setLoadingRows] = useState(false);

    const cellFormatter = (params) => {
        return formatNumber(params.value);
      };
      
      const formatNumber = (number) => {
        return Number(number).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };
      

    const [columnDefs, setColumnDefs] = useState([
        // { field: 'ID', headerName: 'ID', enablePivot: false},
        //c406 columns grouping
        { field: 'year', headerName: 'Year', pivot: true, sortable: false },
        { field: 'period', headerName: 'Period', pivot: true, sortable: false },
        //
        { field: 'docDate', headerName: 'Doc Date', minWidth: 190 },
        { field: 'coCode', headerName: 'CoCode'},
        { field: 'profitCtr', headerName: 'Profit Ctr' },
        { field: 'costCtr', headerName: 'Cost Ctr' },
        { field: 'trPrt', headerName: 'Tr.Prt' },
        { field: 'account', headerName: 'Account' },
        { field: 'gLAcctLongText', headerName: 'G/L Acct Long Text' },
        { field: 'documentNo', headerName: 'Document No', enablePivot: false },
        { field: 'salesOrd', headerName: 'Sales ord.' },
        { field: 'order', headerName: 'Order' },
        { field: 'material', headerName: 'Material' },
        { field: 'purDoc', headerName: 'Pur. Doc.' },
        { field: 'vendCustNo', headerName: 'Vend/Cust No' },
        { field: 'wbsElement', headerName: 'WBS element' },
        { field: 'userName', headerName: 'User name' },
        { field: 'amountInDocCurr', headerName: 'Amount in doc. curr.', enablePivot: false,cellStyle: { textAlign: 'right' }, },
        { field: 'curr', headerName: 'TC' },
        { field: 'amountInLocalCurr', headerName: 'Amount in local cur.', enablePivot: false ,cellStyle: { textAlign: 'right' },},
        { field: 'lCurr', headerName: 'LC' },
        { field: 'reference', headerName: 'Reference' },
        { field: 'assignment', headerName: 'Assignment' },
        { field: 'documentHeaderText', headerName: 'Document Header Text' },
        { field: 'text', headerName: 'Text' },
        { field: 'Proj_Master', headerName: 'Proj Master' },
        // { field: 'FXReference', headerName: 'FX Reference' },
        { field: 'AmountUSD', headerName: 'Amount USD', aggFunc: "sum", enablePivot: false, cellStyle: { textAlign: 'right' },valueFormatter: cellFormatter},
        { field: 'Year_Period', headerName: 'Year-Period' },
        { field: 'Cust_Name', headerName: 'Cust Name' },
        { field: 'GL_Category3', headerName: 'GL Category3'},
        { field: 'Channel', headerName: 'Channel'},
        { field: 'Channel2', headerName: 'Channel2', },
        { field: 'WBS_Name', headerName: 'WBS Name' },
        { field: 'WBS_Status', headerName: 'WBS Status' },
        { field: 'WBS_Element2', headerName: 'WBS Element2' },
        { field: 'PROJECT_NAMES', headerName: 'PROJECT NAMES' },
        { field: 'WBS_Level', headerName: 'WBS Level' },
        { field: 'WBS_Element_Name', headerName: 'WBS Element Name' },
        { field: 'PC_Name', headerName: 'PC Name' },
        { field: 'GL_Grouping_L1', headerName: 'GL Grouping L1' },
        //row grouping
        { field: 'GL_Category2', headerName: 'GL Category2', rowGroup: true, enableRowGroup: true},
        { field: 'GL_Description', headerName: 'GL Description', rowGroup: true, enableRowGroup: true },
        { field: 'Assignment_Proj_Tag', headerName: 'Assignment Proj Tag', rowGroup: true, enableRowGroup: true },
        { field: 'wbsElement', headerName: 'WBS Element', rowGroup: true, enableRowGroup: true },
        //
        { field: 'Proj_Description', headerName: 'Proj Description' },
        { field: 'Product_Line', headerName: 'Product Line' },
        { field: 'PMP_Channel1', headerName: 'PMP Channel1' },
        { field: 'PMP_Channel2', headerName: 'PMP Channel2' },
        { field: 'PMP_Project_Number', headerName: 'PMP Project Number' },
        { field: 'PMP_Project_Name', headerName: 'PMP Project Name' },
        { field: 'PMP_CoCode', headerName: 'PMP CoCode' },
        { field: 'PMP_Country_Of_Work', headerName: 'PMP Country Of Work' },
        { field: 'PMP_Location', headerName: 'PMP Location' },
        { field: 'PMP_Market', headerName: 'PMP Market' },
        { field: 'PMP_Customer', headerName: 'PMP Customer' },
        { field: 'PMP_Framework_Agreement', headerName: 'PMP Framework Agreement' },
        { field: 'PMW_WBS_Element', headerName: 'PMW WBS Element' },
        { field: 'PMW_WBS_Element_Name', headerName: 'PMW WBS Element Name' },
        { field: 'PMW_Revenue_Type', headerName: 'PMW Revenue Type' },
        { field: 'PMP_Risk_Profile', headerName: 'PMP Risk Profile' },
        { field: 'PMP_Service', headerName: 'PMP Service' },
    ]);
    
    useEffect(() => {
        if(rawProjectSummeryList.length==0 && !isRawProjectSummeryListLoading){
            onFetchRawProjectSummeryList({ tableName: 'Project_Summary_Consol', pageNumber: pageNumber, pageSize: pageSize });
        }
    }, [])

    // Check for changes in rawProjectSummeryList and fetch more data if needed
    useEffect(() => {
        if (rawProjectSummeryList.length > 0) {
            // const year = [...new Set(rawProjectSummeryList.map(item => item.year))];
            // const filteredRow= rawProjectSummeryList.filter(item => item.year==year[0])
            // setSelectedYear(year[0])
            setRowData(rawProjectSummeryList);
            // setYear(year);
        }
    }, [rawProjectSummeryList]);

    // Check for row data on the basic of year
    // useEffect(() => {
    //     if (rawProjectSummeryList.length > 0) {
    //         const filteredRow= rawProjectSummeryList.filter(item => item.year==selectedYear)
    //         setRowData(filteredRow);
    //     }
    // }, [selectedYear]);


    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            const columns = sheet[0].map((header, index) => ({
                field: header,
                editable: true,
                filter: true,
                enableValue: header !== 'name' && header !== 'id',
                rowDrag: index === 0 ? true : false
            }));

            const rows = sheet.slice(1).map((row) =>
                row.reduce((acc, value, index) => {
                    acc[sheet[0][index]] = value;
                    return acc;
                }, {})
            );

            setColumnDefs(columns);
            // setRowData(rows);
        };
        reader.readAsBinaryString(file);
    };

    const onRowDragEnd = (event) => {
        const { node, overNode } = event;
        if (!overNode) return;

        const draggedRow = node.data;
        const fromIndex = node.rowIndex;
        const toIndex = overNode.rowIndex;

        if (fromIndex === toIndex) return;

        const newRowData = [...rowData];
        newRowData.splice(fromIndex, 1);
        newRowData.splice(toIndex, 0, draggedRow);

        setRowData(newRowData);
    };

   

   

    const gridStyle = useMemo(() => ({ height: "99%", width: "100%" }), []);

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 200,
            // floatingFilter: true,
            resizable: true,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true,
            // filter: true,
            filterParams: {
            comparator: (a, b) => a.localeCompare(b)
            },
        };
    }, []);

    const rowSelection = useMemo(() => {
        return { mode: "multiRow" };
    }, []);

    const onGridReady = useCallback((params) => {
        if (isRawProjectSummeryListLoading) {
            params.api.showLoadingOverlay();
        } else {
            params.api.hideOverlay();
        }
    }, [isRawProjectSummeryListLoading]);

    // Update loading state
    useEffect(() => {
        if (gridRef.current && gridRef.current.api) {
            if (isRawProjectSummeryListLoading) {
                gridRef.current.api.showLoadingOverlay();
            } else {
                gridRef.current.api.hideOverlay();
            }
        }
    }, [isRawProjectSummeryListLoading]);

    // Update loading state
    useEffect(() => {
        if (gridRef.current && gridRef.current.api) {
            if (loadingRows) {
                gridRef.current.api.showLoadingOverlay();
            } else {
                gridRef.current.api.hideOverlay();
            }
        }
    }, [loadingRows]);

    const [statusBar] = useState({
        statusPanels: [
            {
                statusPanel: 'agTotalRowCountComponent',
                align: 'left'
            },
            // {
            //     statusPanel: 'agSelectedRowCountComponent',
            //     align: 'left'
            // },
            // {
            //     statusPanel: 'agFilteredRowCountComponent',
            //     align: 'left'
            // }
        ]
    });
    
    const autoGroupColumnDef = useMemo(() => {
        return {
            minWidth: 150,
            pinned: "left",
            cellRendererParams: {
            suppressCount: true,
            }
        };
    }, []);

    const onSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        console.log('Selected Row Details:', selectedRows);
        setSelectModel(selectedRows)
        // You can do further processing with selectedRows here, e.g., updating state
    };

    //
    const sideBar = useMemo(() => { 
        return {
            toolPanels: ['columns', 'filters']
        };
    }, []);

    return (
        <div style={{ height: 'calc(100vh - 120px)', overflow: 'auto', position: 'relative' }}>
            <div className={`ag-grid ${theme} custom-grid-theme`} style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    rowDragManaged={true}
                    onRowDragEnd={onRowDragEnd}
                    defaultColDef={defaultColDef}
                    // rowSelection={rowSelection}
                    onGridReady={onGridReady}
                    sideBar={sideBar}
                    pivotMode={true}
                    //
                    pivotPanelShow={"always"}
                    autoGroupColumnDef={autoGroupColumnDef}
                    animateRows={true}
                    onSelectionChanged={onSelectionChanged}
                    enableFilter={true}
                    statusBar={statusBar}
                    groupDefaultExpanded={3}
                    pivotDefaultExpanded={2}
                    // pivotRowTotals={"after"}
                    // pivotColumnTotals={true}
                    groupTotalRow={"bottom"}
                    grandTotalRow={"bottom"}
                    groupDisplayType={"multipleColumns"}
                    showOpenedGroup={true}
                    suppressGroupRowsSticky={true}
                    groupHideOpenParents={true}
                    rowHeight={40}
                    headerHeight={40}
                    enableStrictPivotColumnOrder = {true}
                    removePivotHeaderRowWhenSingleValueColumn ={true}
                   
                />
            </div>
        </div>
    );
};

const mapStateToProps = ({ projectMarginReducer }) => {
    const isRawProjectSummeryListLoading = get(projectMarginReducer, 'isRawProjectSummeryListLoading', false);
    const rawProjectSummeryList = get(projectMarginReducer, 'rawProjectSummeryList', []);

    return {
        isRawProjectSummeryListLoading,
        rawProjectSummeryList,
    }
}

const mapDispatchToProps = {
    onFetchRawProjectSummeryList: fetchRawProjectSummeryList,
}

export default connect(mapStateToProps, mapDispatchToProps)(Cji3C406);
